export default __webpack_public_path__ + "static/media/newBorn.a45e5cf3.svg";